import React, { useEffect, useState, useMemo, useCallback } from "react";
import { Client } from "../requests";
import { Link } from "react-router-dom";
import Card from "react-bootstrap/Card";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import debounce from "lodash/debounce";

const ClientIndexPage = (props) => {
  const [clients, setClients] = useState([]);
  const [search, setSearch] = useState("");
  const [pagination, setPagination] = useState({ page: 1, pages: 1 });
  const [page, setPage] = useState(1);

  // Debounced fetch
  const fetchClients = useCallback(
  debounce((pageNum, q) => {
    Client.index({ page: pageNum, q }).then((data) => {
      setClients(data.clients || []);
      setPagination(data.pagination || { page: 1, pages: 1 });
    }).catch((err) => {
      console.error("Failed to fetch clients:", err);
      setClients([]);
      setPagination({ page: 1, pages: 1 });
    });
  }, 400),
  []
);

  useEffect(() => {
    fetchClients(page, search);
  }, [page, search, fetchClients]);

  const deleteClient = (id) => {
    if (
      window.confirm(
        "Are you sure you want to delete this client? This action cannot be undone!"
      )
    ) {
      Client.destroy(id).then(() => {
        setClients(clients.filter((c) => c.id !== id));
      });
    }
  };

  return (
    <>
      <Form className="pb-5">
        <h1 className="text-center">Client Index</h1>

        <Form.Group className="mb-3" controlId="formForNameCode">
          <Form.Control
            type="text"
            placeholder="Search by name"
            value={search}
            onChange={(e) => {
              setSearch(e.target.value);
              setPagination({ ...pagination, page: 1 }); // reset to first page when searching
            }}
          />
          <br />
          {clients && clients.length > 0 ? (

            clients.map((client) => (
              <Card key={client.id}>
                <Card.Body className="d-flex justify-content-between">
                  <Link className="mt-1" to={`/clients/${client.id}`}>
                    {client.first_name} {client.last_name}
                  </Link>
                  {props.currentUser?.admin ? (
                    <Button
                    variant="outline-danger"
                    onClick={() => deleteClient(client.id)}
                    >
                      Delete Client
                    </Button>
                  ) : null}
                </Card.Body>
              </Card>
          )
            )): (
              <p>No Clients found</p>
            )}
        </Form.Group>
      </Form>

      {/* Pagination controls */}
      {pagination.pages > 1 && (
        <div className="flex gap-2 mt-4">
          <button
            disabled={pagination.page <= 1}
            onClick={() =>
              setPagination({ ...pagination, page: pagination.page - 1 })
            }
            className="px-2 py-1 border rounded disabled:opacity-50"
          >
            Prev
          </button>

          <span>
            Page {pagination.page} of {pagination.pages}
          </span>

          <button
            disabled={pagination.page >= pagination.pages}
            onClick={() =>
              setPagination({ ...pagination, page: pagination.page + 1 })
            }
            className="px-2 py-1 border rounded disabled:opacity-50"
          >
            Next
          </button>
        </div>
      )}
    </>
  );
};

export default ClientIndexPage;
